import React, { useEffect, useState } from "react";
import styled from "styled-components";
import SupplyChainIndexItemFlags from "../baitToPlate/BaitToPlateIndexItemFlags";
import getDiscussionEntityFlagsFromSupplyChain from "../../utilities/getDiscussionEntityFlagsFromSupplyChain";

import dataFlags from "../../data/bait-to-plate/data-flags-combined.json";

import cleanCompanyName from "../../utilities/cleanCompanyName";

import isBoolean from "../../utilities/isBoolean";
import DiscussionInteractionCount from "./DiscussionInteractionCount";
import DiscussionEntityLink from "./DiscussionEntityLink";

const DiscussionList = ({ items, getEntityHash, getEntityTitle }) => {

  return (
    <>
      <StyledDiscussionListHeader>
        <div><span>Name</span></div>
        <div><span>Crimes & Concerns (direct & *linked)</span></div>
        <div><span>Country</span></div>
        <div><span>Type</span></div>
        <div><span>Inquiries / Replies</span></div>
      </StyledDiscussionListHeader>
      <StyledDiscussionList>
        {items.map((item, index) => {

          return (
            <DiscussionListItem 
              key={index} 
              entity={item} 
              getEntityHash={getEntityHash} 
              getEntityTitle={getEntityTitle} 
            />
          )
        })}
        {items.length === 0 && (
          <li className="empty">
            <div>No results found for selected filters.</div>
          </li>
        
        )}
      </StyledDiscussionList>
    </>
  );
};

export default DiscussionList;

const StyledDiscussionListHeader = styled.div`
  
  display: none;

  @media ( min-width: 48em ) {
    position: sticky;
    display: block;
    z-index: 10;
    top: calc( (var(--navbar-height) + 77px) );
    background-color: var(--color-black);
    border-bottom: 1px solid rgba(255,255,255,0.5);
    gap: 3em;
    padding: 0.75em 0;
    padding-top: calc(1.5em + 0.75em);
    margin-top: -1.5em;
    box-shadow: 0 -1px 0 0 var(--color-black);

    display: grid;
    grid-template: 1fr / 1fr 1fr 8em 3em 8em;
    gap: 3em;
    span {
      font-size: 0.875em;
      font-weight: 700;
      opacity: 0.6;
    }

    .center {
      text-align: center;
    }
  }
`;

const StyledDiscussionList = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0 0 1.5em;
  .empty {
    padding: 8em 0;
    text-align: center;
    font-size: 0.875em;
    opacity: 0.5;
  
  }
`;


const DiscussionListItem = ({ entity, getEntityHash, getEntityTitle }) => {
  
  const hasFlags = entity.flags?.length > 0 || entity.processor_flags?.length > 0 || entity.vessel_flags?.length > 0;


  return (
    <StyledDiscussionListItem>
      <div className="name-wrap">
        <div className="name">
          <DiscussionEntityLink entity={entity} />
        </div>
        {entity.name_mandarin && (<div className="name-mandarin">{entity.name_mandarin}</div>)}
      </div>
      <SupplyChainIndexItemFlags item={entity} asSummary={true} />
      <div className="details">
        <div className="detail">{entity?.country?.name}</div>
      </div>
      <div>
        <div className="detail"><div className="detail-label">Type: </div>{entity.type.toUpperCase()}</div>
      </div>
      <div className="interactions">
        <DiscussionInteractionCount inquiries={entity.count_inquiries} replies={entity.count_replies} />
      </div>
      {/*<div className="details">
        {item.type === "vessel" && item.imo && (<div className="detail"><span className="detail-label">IMO: </span>{item.imo}</div>)}
        {item.country && (<div className="detail">{item.country}</div>)}
        {item.type === "processor" && isBoolean(item.is_msc_certified) && item.is_msc_certified && (
          <div className="detail cert">MSC Certified</div>
        )}
        {item.type === "processor" && isBoolean(item.is_eu_export_authorized) && item.is_eu_export_authorized && (
          <div className="detail cert">E.U. Export Authorized</div>
        )}
        </div>*/}
    </StyledDiscussionListItem>
  );
}

const StyledDiscussionListItem = styled.li`
  padding: 1em 0;
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  align-items: start;
  @media ( max-width: 48em ) {
    flex-direction: row;
    flex-wrap: wrap;
    .name-wrap, 
    > ul,
    .interactions {
      flex: 1 1 100%;
    }
  }
  @media ( min-width: 48em ) {
    display: grid;
    grid-template: 1fr / 1fr 1fr 8em 3em 8em;
    gap: 3em;
  }
  &:not(:last-of-type) {
    border-bottom: 1px solid rgba(255,255,255,0.2);
  }
  .name-wrap {
    display: flex;
    flex-direction: column;
    gap: 0.25em;
  }
  .name {
    font-size: 1em;
    font-weight: 700;
    line-height: 1.2;
    a {
      text-decoration-line: underline;
      text-decoration-thickness: 0.75px;
      text-underline-offset: 0.1em;
      text-decoration-color: rgba(255,255,255,0.4);
      .can-hover &:hover,
      &:active {
        text-decoration-color: currentColor;
      }
    }
    @media ( min-width: 48em ) {
      font-size: 1.125em;
    }
  }
  .name-mandarin {
    font-size: 0.8125em;
    font-weight: 500;
    opacity: 0.5;
    @media ( min-width: 48em ) {
      font-size: 0.875em;
    }
  }
  .detail {
    font-size: 0.75em;
    font-weight: 500;
    @media ( max-width: 48em ) {
      display: flex;
      gap: 0.25em;
    }
    @media ( min-width: 48em ) {
      font-size: 0.875em;
      .detail-label {
        display: none;
      }
    }
  }
  .interactions {
    @media ( min-width: 48em ) {
      display: flex;
      justify-content: center;
      span {
        display: none;
      }
    }
  }
`;